import React from 'react'

import { Avatar, Chip, Dialog, DialogContent, Stack } from '@mui/material'

type DisplayMoreDialogProps = {
  id: string
  values: string[]
  open: boolean
  onClose: () => void
  showAvatar?: boolean
}

const DisplayMoreDialog = ({
  id,
  open,
  onClose,
  values,
  showAvatar,
}: DisplayMoreDialogProps) => {
  const handleClose = () => {
    onClose()
  }

  return (
    <Dialog id={id} onClose={handleClose} open={open}>
      <DialogContent>
        <Stack direction="row" spacing={0.5}>
          {values.map((value) => (
            <Chip
              avatar={
                showAvatar ? (
                  <Avatar>{value.charAt(0).toUpperCase()}</Avatar>
                ) : undefined
              }
              key={value}
              label={value}
              variant="outlined"
            />
          ))}
        </Stack>
      </DialogContent>
    </Dialog>
  )
}

export default DisplayMoreDialog
